import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const PrintReport: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.PRINT_REPORT,
            value: value ? '1' : '0',
          })
        }
        value={settings.shouldPrintReport}
        label={t('settings.billing.work.print.title')}
        description={t('settings.billing.work.print.description')}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
